namespace Solovis.Portal {

    export interface ICachedPermissions {
        doesUserHavePermission(permissionName: string);
        canUserEditMarketValue(book?: boolean);
        canUserEditPerformance(book?: boolean);
        canUserEditExchangeRate(book?: boolean);
    }

  
    export class CachedPermissionsClient implements ICachedPermissions {

        private _portalServices: Solovis.Portal.IPortalServices;

        constructor(portalServices?: Solovis.Portal.IPortalServices) {            
            this._portalServices = portalServices;            
        }

        public doesUserHavePermission(permissionName: string) {
            if (!this._portalServices) {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            // These permissions are loaded via ClientScript client-cached script. Permissions
            // are enforced server-side, but we can use the list of cached permissions to present
            // the user a list of things that they could do within the user interface.
            let solovisCustom = this._portalServices.customEnvironmentUserData();
            if (solovisCustom && solovisCustom.UserPermissions) {
                return solovisCustom.UserPermissions[permissionName] === true;
            }

            return false;
        }

        public canUserEditMarketValue(book?: boolean) {
            if (this.doesUserHavePermission("MarketValueEdit")) {
                if (!book || this.doesUserHavePermission("BookValueEdit")) {
                    return true;
                }
            }

            return false;
        }

        public canUserEditPerformance(book?: boolean) {
            if (this.doesUserHavePermission("PerformanceEdit")) {
                if (!book || this.doesUserHavePermission("BookValueEdit")) {
                    return true;
                }
            }

            return false;
        }

        public canUserEditExchangeRate(book?: boolean) {
            if (this.doesUserHavePermission("ForexExchangeRateEdit")) {
                if (!book || this.doesUserHavePermission("BookValueEdit")) {
                    return true;
                }
            }

            return false;
        }
    }


    export const CachedPermissions = new CachedPermissionsClient();
    
}